var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "gvl-funding" }, [
      _c("div", { staticClass: "notice-box" }, [
        _vm._v(
          "Das Antragsportal wurde vorzeitig geschlossen, da die Mittel aufgrund der Anzahl an Anträgen bereits ausgeschöpft sind."
        )
      ]),
      _c("p", [
        _vm._v(
          "Genaue Informationen zur Antragstellung, zum Förderverfahren und zur Abrechnung der Förderung finden Sie in den FAQ und in den Fördergrundsätzen. Bitte lesen Sie die Informationen vor allem in den FAQ gründlich durch, bevor Sie Ihren Antrag stellen."
        )
      ]),
      _c("p", [
        _vm._v("Bei weiteren Fragen wenden Sie sich an unsere Hotline unter:")
      ]),
      _c("p", { staticClass: "text-center mt-3 mb-2" }, [
        _c("strong", [_vm._v("0202-2515 57305")])
      ]),
      _c("p", { staticClass: "text-center" }, [
        _vm._v("Montag bis Sonntag von 6:00 bis 22:00 Uhr")
      ]),
      _c("p", { staticClass: "mt-4" }, [
        _vm._v(
          "Nutzen Sie ausschließlich die o.g. Rufnummer. Die dortigen Ansprechpartner sind geschult, Ihnen weiterzuhelfen. Andere Mitarbeiter der GVL können Ihnen bezüglich des GVL-Stipendienprogramms nicht weiterhelfen. Anfragen per E-Mail können leider nicht berücksichtig werden."
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }